export default __webpack_public_path__ + "static/media/best_airdrop.fc08b9ae.svg";